import React from "react";
import { Alert, Box, Button, Chip, CircularProgress, LinearProgress, Stack, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getOnlineAdditionalActReadiness } from "./onlineAdditionalActReadiness";

export default function OnlineAdditionalActChecklist({ data, newPrice, loading = false, error = "", onRefresh }) {
  const readiness = getOnlineAdditionalActReadiness({ data, newPrice, loading, error });
  const progress = (readiness.completedCount / readiness.totalCount) * 100;

  return (
    <Box component="section" aria-label="Date necesare pentru actul adițional LP015"
      sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2.5, bgcolor: "#fff", border: "1px solid #e4dced", boxShadow: "0 4px 16px rgba(70, 30, 100, 0.04)" }}>
      <Stack direction="row" spacing={1.5} alignItems="flex-start" justifyContent="space-between">
        <Box>
          <Typography fontWeight={800} sx={{ color: "#5b2182" }}>Date necesare pentru actul adițional</Typography>
          <Typography variant="body2" sx={{ mt: 0.5, color: "#475467" }}>
            Verifică informațiile pentru LP015. Datele lipsă sunt marcate cu roșu.
          </Typography>
        </Box>
        {onRefresh && <Button size="small" onClick={onRefresh} disabled={loading} aria-label="Reîncarcă verificările actului adițional"
          startIcon={<RefreshIcon />} sx={{ color: "#6a0dad", flexShrink: 0, textTransform: "none" }}>Actualizează</Button>}
      </Stack>
      <Chip label={`${readiness.completedCount}/${readiness.totalCount} completate`} size="small"
        sx={{ mt: 1.5, fontWeight: 750, bgcolor: "#f3e8ff", color: "#5b2182" }} />
      <LinearProgress variant="determinate" value={progress}
        aria-label={`${readiness.completedCount} din ${readiness.totalCount} condiții completate`}
        sx={{ mt: 1.5, height: 7, borderRadius: 4, bgcolor: "#eee7f4", "& .MuiLinearProgress-bar": { bgcolor: "#8b5bb6", borderRadius: 4 } }} />
      {loading && <Alert severity="info" icon={<CircularProgress size={19} color="inherit" />} sx={{ mt: 2 }}>Se verifică informațiile din Jira și datele furnizorului…</Alert>}
      {!loading && (error || !data) && <Alert severity="warning" sx={{ mt: 2 }}>{error || "Datele produsului nu sunt încă disponibile pentru verificare."}</Alert>}
      <Box component="ul" sx={{ p: 0, m: 0, mt: 2, listStyle: "none", display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }, gap: 1.25 }}>
        {readiness.requirements.map((item) => (
          <Box component="li" key={item.id} sx={{ display: "flex", alignItems: "flex-start", gap: 1, minWidth: 0, p: 1.5,
            borderRadius: 2, bgcolor: item.isComplete ? "#f0fdf4" : "#fff5f5", border: `1px solid ${item.isComplete ? "#c4e8cd" : "#f4cccc"}` }}>
            {item.isComplete
              ? <CheckCircleRoundedIcon aria-hidden="true" sx={{ color: "#15803d", fontSize: 21, mt: 0.1 }} />
              : <CancelRoundedIcon aria-hidden="true" sx={{ color: "#b42318", fontSize: 21, mt: 0.1 }} />}
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="body2" sx={{ color: "#182230", fontWeight: 700, lineHeight: 1.35 }}>{item.label}</Typography>
              <Typography variant="caption" sx={{ display: "block", mt: 0.5, color: item.isComplete ? "#166534" : "#9f2922", lineHeight: 1.45, overflowWrap: "anywhere" }}>
                {item.isComplete ? item.value : item.missingMessage}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
